<template>
  <v-container fluid>
    <div class="d-flex mb-2">
      <h2 class="ml-1" style="font-weight: 400">Microsoft Entra ID</h2>
    </div>
    <v-card outlined class="pa-4">
      <v-form ref="form" lazy-validation>
        <v-switch
          v-model="microsoftEntraId.ms_entraid_enable"
          class="mt-0"
          :label="
            microsoftEntraId.ms_entraid_enable
              ? 'เปิดการใช้งาน'
              : 'ปิดการใช้งาน'
          "
        ></v-switch>
        <div>
          <label class="body-2">Authorization Endpoint</label>
          <v-text-field
            v-model="microsoftEntraId.ms_entraid_authorization_endpoint"
            :rules="[allOrNothing, httpsRule]"
            class="fix-google-chrome mt-1"
            clearable
            @change="checkEmpty($event, 'ms_entraid_authorization_endpoint')"
            outlined
            dense
          ></v-text-field>
        </div>
        <div>
          <label class="body-2">Token Endpoint</label>
          <v-text-field
            v-model="microsoftEntraId.ms_entraid_token_endpoint"
            :rules="[allOrNothing, httpsRule]"
            class="fix-google-chrome mt-1"
            clearable
            @change="checkEmpty($event, 'ms_entraid_token_endpoint')"
            outlined
            dense
          ></v-text-field>
        </div>
        <div>
          <label class="body-2">Client ID</label>
          <v-text-field
            v-model="microsoftEntraId.ms_entraid_client_id"
            :rules="[allOrNothing]"
            class="fix-google-chrome mt-1"
            clearable
            @change="checkEmpty($event, 'ms_entraid_client_id')"
            outlined
            dense
          ></v-text-field>
        </div>
        <div>
          <label class="body-2">Client Secret</label>
          <v-text-field
            v-model="microsoftEntraId.ms_entraid_client_secret"
            :rules="[allOrNothing]"
            class="fix-google-chrome mt-1"
            clearable
            @change="checkEmpty($event, 'ms_entraid_client_secret')"
            outlined
            dense
          ></v-text-field>
        </div>
      </v-form>
    </v-card>

    <div class="mt-4 mb-10">
      <v-btn
        class="mr-2"
        color="primary"
        :disabled="
          !isConfigMicrosoftEntraIdDataChange ||
          (uiCtrl &&
            !uiCtrl.isEnable('btn:::company_config:microsoft_entra_id:update'))
        "
        @click="onSave"
        >บันทึก</v-btn
      >
      <v-btn @click="onCancel">ยกเลิก</v-btn>
    </div>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'MicrosoftEntraId',
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      microsoftEntraId: {},
      microsoftEntraIdInit: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isConfigMicrosoftEntraIdDataChange() {
      if (
        this.microsoftEntraId.ms_entraid_authorization_endpoint !==
          this.microsoftEntraIdInit.ms_entraid_authorization_endpoint ||
        this.microsoftEntraId.ms_entraid_token_endpoint !==
          this.microsoftEntraIdInit.ms_entraid_token_endpoint ||
        this.microsoftEntraId.ms_entraid_client_id !==
          this.microsoftEntraIdInit.ms_entraid_client_id ||
        this.microsoftEntraId.ms_entraid_client_secret !==
          this.microsoftEntraIdInit.ms_entraid_client_secret ||
        this.microsoftEntraId.ms_entraid_enable !==
          this.microsoftEntraIdInit.ms_entraid_enable
      ) {
        return true
      }
      return false
    },
    allOrNothing() {
      const values = Object.entries(this.microsoftEntraId)
        .filter(([k]) => k !== 'ms_entraid_enable')
        .map(([, v]) => v)
      const filled = values.filter((v) => !!v).length

      if (filled === 0) return true // all empty = ok
      if (filled === values.length) return true // all filled = ok
      return 'กรุณากรอกทุกช่องหรือปล่อยให้ว่างทั้งหมด'
    },
    httpsRule() {
      return (v) => {
        if (!v) return true
        return (
          /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(
            v
          ) || 'URL ไม่ถูกต้อง'
        )
      }
    },
  },
  watch: {
    uiCtrl(value) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('menu:::company_config:microsoft_entra_id')
      ) {
        this.$router.push({ name: 'Home' })
      } else if (
        value &&
        this.uiCtrl &&
        this.uiCtrl.isEnable('row:::company_config:microsoft_entra_id:get')
      ) {
        this.loadData()
      }
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'Microsoft Entra ID',
        disabled: true,
      },
    ])

    if (
      this.uiCtrl &&
      !this.uiCtrl.isEnable('row:::company_config:microsoft_entra_id:get')
    ) {
      this.dialogForbidden = true
      return
    }

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchConfigMicrosoftEntraId:
        'microsoftEntraId/fetchConfigMicrosoftEntraId',
      updateConfigMicrosoftEntraId:
        'microsoftEntraId/updateConfigMicrosoftEntraId',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.microsoftEntraId[field] = value.trim()
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          const values = Object.entries(this.microsoftEntraId)
            .filter(([k]) => k !== 'ms_entraid_enable')
            .map(([, v]) => v)
          const filled = values.filter((v) => !!v).length

          this.$store.state.loading = true

          const response = await this.updateConfigMicrosoftEntraId({
            company_uuid,
            data: {
              ms_entraid_authorization_endpoint:
                this.microsoftEntraId.ms_entraid_authorization_endpoint || null,
              ms_entraid_token_endpoint:
                this.microsoftEntraId.ms_entraid_token_endpoint || null,
              ms_entraid_client_id:
                this.microsoftEntraId.ms_entraid_client_id || null,
              ms_entraid_client_secret:
                this.microsoftEntraId.ms_entraid_client_secret || null,
              ms_entraid_enable:
                filled === 0 ? null : this.microsoftEntraId.ms_entraid_enable,
            },
          })
          this.microsoftEntraId = { ...response }
          this.microsoftEntraIdInit = { ...response }

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 4000,
            message: 'บันทึกข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    onCancel() {
      this.microsoftEntraId = { ...this.microsoftEntraIdInit }
    },
    async loadData() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        const response = await this.fetchConfigMicrosoftEntraId({
          company_uuid,
        })
        this.microsoftEntraId = { ...response }
        this.microsoftEntraIdInit = { ...response }
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      this.confirmDialogDataChange = false
      this.nextRoute(item.data)
    },
    nextRoute(next) {
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isConfigMicrosoftEntraIdDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
